import { Collapse } from 'antd';
import { memo } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFSupportLeft } from '@/components/UI/svg/Support';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import { getFaqsInProd } from '@/service';

const { Panel } = Collapse;

function Child({ isMobile = false }) {
    const { useState, useEffect, useLang, gtm, useRouter } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const [fagList, setFaqList] = useState([]);
    const [activeKey, setActiveKey] = useState(0);
    const { locale } = useRouter();

    const onCollapseChange = (key: any) => {
        setActiveKey(key);

        const filterItem = fagList.find((v: any) => v.faqInfoId === (key ? key : activeKey));

        if (filterItem) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'select_faq',
                title_name: filterItem?.title,
                status: key ? 'open' : 'close',
            });
        }
    };

    const catagoryIds = ['1514858700785975298', '1515217621539225602', '1514859142563627010', '1514859508848001026', '1514859290417037313'];

    const getFaqs = () => {
        getFaqsInProd({ productCatagoryIds: catagoryIds.join(',') }, locale).then((res: any) => {
            if (res.code === '0') {
                const { content } = res.data;
                setFaqList(content);
            }
        });
    };

    useEffect(() => {
        getFaqs();
    }, []);

    return (
        <div className={css.faq}>
            <h3 className="title">
                <span className="icon">
                    <EFSupportLeft />
                </span>
                <span className="text">{t('presale.faq.frequently_asked_questions')}</span>
            </h3>
            <div className="faq-list">
                <Collapse
                    accordion
                    bordered={false}
                    defaultActiveKey="2"
                    expandIcon={({ isActive }) => (
                        <div
                            style={{
                                top: '20%',
                                transform: isMobile ? (isActive ? 'rotate(-180deg)' : 'rotate(0deg)') : isActive ? 'rotate(0deg)' : 'rotate(-90deg)',
                                transition: 'all .3s',
                                lineHeight: 0,
                                right: 0,
                            }}
                        >
                            <EFArrowDown />
                        </div>
                    )}
                    expandIconPosition="right"
                    className={`${css.supports} site-collapse-custom-collapse`}
                    onChange={onCollapseChange}
                >
                    {fagList.map((faq: any) => (
                        <Panel className="site-collapse-custom-panel" header={faq.title} key={faq.faqInfoId}>
                            <p className="text">{faq.description}</p>
                        </Panel>
                    ))}
                </Collapse>
            </div>
        </div>
    );
}

const ChildMemo = memo(Child);

export default function FAQ({ isMobile }: any) {
    return <ChildMemo isMobile={isMobile} />;
}
